import { render, staticRenderFns } from "./SwitchLanguage.vue?vue&type=template&id=a5ac89b2&scoped=true"
import script from "./SwitchLanguage.vue?vue&type=script&lang=js"
export * from "./SwitchLanguage.vue?vue&type=script&lang=js"
import style0 from "./SwitchLanguage.vue?vue&type=style&index=0&id=a5ac89b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ac89b2",
  null
  
)

export default component.exports